import { render } from "./WoodMaterialsPriceBanner.vue?vue&type=template&id=2bfc0740&scoped=true"
import script from "./WoodMaterialsPriceBanner.vue?vue&type=script&lang=js"
export * from "./WoodMaterialsPriceBanner.vue?vue&type=script&lang=js"

import "./WoodMaterialsPriceBanner.vue?vue&type=style&index=0&id=2bfc0740&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfc0740"]])

export default __exports__